import React, { useState, useEffect, useRef } from "react";

// Formik Validation
import * as Yup from "yup";
import { useFormik as useFormic, useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
//redux
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { TailSpin } from "react-loader-spinner";
import callApi from "Common/utils/apiCaller";
import { createSelector } from "reselect";
import BreadCrumb from "Common/BreadCrumb";
import withRouter from "Common/withRouter";
import { editProfile } from "slices/thunk";
import { headingData, loginSuccess } from "slices/auth/login/reducer";

const UserProfile = () => {
  //meta title
  document.title = "Profile | Indxx";
  const userDetail = JSON.parse(window.localStorage.getItem(`authUser`));
  const dispatch = useDispatch<any>();
  const [loader, setLoader] = useState<any>();
  const [address, setAddress] = useState<string>("");
  const [render, setRender] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("admin@gmail.com");
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [gender, setGender] = useState<string>("");
  const [pincode, setPincode] = useState<string>("");
  const [showAlert, setShowAlert] = useState(false);
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      user: profile.user,
      error: profile.error,
      success: profile.success,
    })
  );
  const originalEmailRef = useRef(email);


  const [otpVisible, setOtpVisible] = useState(false);
const [otp, setOtp] = useState("");

const handleVerifyOtp = async () => {
  try {
    const res = await callApi(`v1/admin/verify-email-otp`, "post", {
      contact_email: validation.values.contact_email,
      otp,
    });

    if (res?.status?.toLowerCase() === "success") {
      toast.success("Email verified and updated.");
      setOtpVisible(false);
      setRender(!render);
    } else {
      toast.error("Invalid OTP. Please try again.");
    }
  } catch (error: any) {
    console.error("OTP verification error:", error);
    toast.error(
      error?.response?.data?.message ||
        error?.message ||
        "Server error while verifying OTP."
    );
    console.log("hhh", error?.message);
  }
};

  const { error, success, user } = useSelector(selectProperties);
  //console.log(user?._id);
  useEffect(() => {
    if (error || success) {
      setShowAlert(true);

      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [error, success]);
  useEffect(() => {
    async function fectchAdmin(id: any) {
      // console.log(user?._id);

      const res = await callApi(`v1/admin/${id}`, "get", {});

      if (res?.status === "Success") {
        dispatch(headingData({ contact_name: res?.data?.admin?.contact_name }));
        setEmail(res?.data?.admin?.contact_email);
        setName(res?.data?.admin?.contact_name);
        setPhone(res?.data?.admin?.contact_phone);
        setGender(res?.data?.admin?.gender);

         originalEmailRef.current = res?.data?.admin?.contact_email;
      }
    }
    if (user && user !== "") {
      fectchAdmin(user);
    }
  }, [user, render]);

const validation = useFormik({
  enableReinitialize: true,

  initialValues: {
    contact_name: name || "admin",
    contact_email: email || "",
    contact_phone: phone || "",
    gender: gender || "",
  },

  validationSchema: Yup.object({
    contact_name: Yup.string()
      .matches(/^[a-zA-Z\s]+$/, "Name must not contain special characters or numbers")
      .required("Please enter your username"),

    gender: Yup.string().required("Please enter your gender"),

    contact_phone: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
      .required("Please enter your phone"),

    contact_email: Yup.string()
      .email("Please enter a valid email")
      .required("Please enter your email"),
  }),

  onSubmit: async (values, { setSubmitting }) => {
    try {
      setLoader(true);
      const isEmailChanged = originalEmailRef.current !== values.contact_email;

      const res = await callApi(`v1/admin/${user}/update`, "post", {
        admin: { ...values },
      });

      if (res?.status === "Success") {
        if (isEmailChanged) {
          setOtpVisible(true);
          toast.info("A verification code has been sent to the new email.");
        } else {
          toast.success("Profile updated successfully");
          setRender(!render);
        }
      } else {
        toast.error("Failed to update profile");
      }
    } catch (err) {
      const serverMsg =
        err?.response?.data?.data?.message ||
        err?.response?.data?.message ||
        err?.message ||
        "Server error while updating profile.";

      if (serverMsg.toLowerCase().includes("validation")) {
        toast.error("Incorrect form format: " + serverMsg);
      } else if (serverMsg.toLowerCase().includes("duplicate")) {
        toast.error("Duplicate entry: " + serverMsg);
      } else {
        toast.error(serverMsg);
      }
    } finally {
      setSubmitting(false);
      setLoader(false);
    }
  },
});


  return (
    <React.Fragment>
      <ToastContainer closeButton={false} limit={1} />
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        {/* Render Breadcrumb */}
        <BreadCrumb title="Indxx Admin" pageTitle="Profile" version="" />

        <div className="row">
          <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-1">
            {showAlert && success && (
              <div
                className="px-4 py-3 mb-3 text-sm text-green-500 border border-green-200 rounded-md bg-green-50 dark:bg-green-400/20 dark:border-green-500/50"
                id="successAlert"
              >
                You have <b>successfully</b> logged in.
              </div>
            )}
            {showAlert && error && (
              <div
                className="px-4 py-3 mb-3 text-sm text-red-500 border border-red-200 rounded-md bg-red-50 dark:bg-red-400/20 dark:border-red-500/50"
                id="errorAlert"
              >
                You have <b>failed</b> to log in.
              </div>
            )}

            <div className="card">
              <div className="card-body">
                <div className="flex items-center gap-3">
                  <div
                    style={{
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "2.5em",
                      height: "2.5em",
                      fontSize: "1.5em",
                      background: "#f1f5f9",
                    }}
                  >
                    <span className="avatar-md rounded-circle img-thumbnail">
                      {_.upperCase(name?.slice(0, 1))}
                    </span>
                  </div>
                  <div className="text-slate-500 dark:text-zink-200">
                    <h5 className="text-slate-500">{name || "admin"}</h5>
                    <p className="mb-1">{email || "admin@gmail.com"}</p>
                    {/* <p className="mb-0">Id no: #{idx || 1}</p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h5 className="mb-4">Change User Detail</h5>

        <div className="card">
          <div className="card-body">
            <form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <label className="inline-block mb-2 text-base font-medium">
                    User Name
                  </label>
                  <input
                    name="contact_name"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter User Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.contact_name || ""}
                  />
                  {validation.touched?.contact_name &&
                  validation.errors?.contact_name ? (
                    <div className="mt-1 text-sm text-red-500">
                      {validation.errors?.contact_name}
                    </div>
                  ) : null}
                </div>
                <div className="xl:col-span-12">
                  <label className="inline-block mb-2 text-base font-medium">
                    Email
                  </label>
                  <input
                    name="contact_email"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter User Email"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.contact_email || ""}
                  />
                  {validation.touched?.contact_email &&
                  validation.errors?.contact_email ? (
                    <div className="mt-1 text-sm text-red-500">
                      {validation.errors?.contact_email}
                    </div>
                  ) : null}
                </div>
                <div className="xl:col-span-12">
                  <label className="inline-block mb-2 text-base font-medium">
                    Phone Number
                  </label>
                  <input
                    name="contact_phone"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Phone Number"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.contact_phone || ""}
                  />
                  {validation.touched?.contact_phone &&
                  validation.errors?.contact_phone ? (
                    <div className="mt-1 text-sm text-red-500">
                      {validation.errors?.contact_phone}
                    </div>
                  ) : null}
                </div>
                <div className="xl:col-span-12">
                  <label className="inline-block mb-2 text-base font-medium">
                    Gender
                  </label>
                  <select
                    onChange={validation.handleChange}
                    value={validation.values.gender || ""}
                    name="gender"
                    id="statusgender"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  >
                    <option value="">Select</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                  {validation.touched?.gender && validation.errors?.gender ? (
                    <div className="mt-1 text-sm text-red-500">
                      {validation.errors?.gender}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="mt-4 text-center">
                <button
                  type="submit"
                  disabled={loader}
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="px-2 py-1.5 text-xs text-white btn bg-red-500 hover:text-white hover:bg-red-600 focus:text-white focus:bg-red-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:ring active:ring-custom-100 dark:bg-red-500/20 dark:text-red-500 dark:hover:bg-red-500 dark:hover:text-white dark:focus:bg-red-500 dark:focus:text-white dark:active:bg-red-500 dark:active:text-white dark:ring-red-400/20"
                >
                  {loader ? (
                    <div className="flex justify-center">
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#4fa94d"
                      />
                    </div>
                  ) : (
                    "update User Profile"
                  )}
                </button>
              </div>
            </form>
{otpVisible && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white dark:bg-zink-700 rounded-lg shadow-lg w-full max-w-md p-6">
      <h3 className="text-lg font-semibold mb-4 text-slate-800 dark:text-white">
        Verify Email
      </h3>

      <p className="mb-4 text-sm text-slate-600 dark:text-zink-200">
        An OTP has been sent to:{" "}
        <span className="font-medium">{validation.values.contact_email}</span>
      </p>

      <label className="block mb-2 text-sm font-medium text-slate-700 dark:text-zink-200">
        Enter OTP
      </label>
      <input
        type="text"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        className="form-input w-full border-slate-300 dark:border-zink-500 mb-4"
        placeholder="Enter OTP"
      />

      <div className="flex justify-end space-x-2">
        <button
          onClick={() => setOtpVisible(false)}
          className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded hover:bg-gray-200 dark:text-zink-200 dark:bg-zink-600 dark:hover:bg-zink-500"
        >
          Cancel
        </button>
        <button
          onClick={handleVerifyOtp}
          className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700"
        >
          Verify OTP
        </button>
      </div>
    </div>
  </div>
)}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
